export default "__VITE_ASSET__Bq5z$ZWt__"